import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { Container } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import { API_URL, sitename } from "constants/constants"
import axios from "axios"
import KYCTable from "./KYCTable"

function KYC() {
  const [KYCData, setKYCData] = useState([])

  useEffect(() => {
    call()
  }, [])

  const call = () => {
    axios({
      method: "get",
      url: `${API_URL}/admin/get-kyc-data`,
    })
      .then(function (response) {
        setKYCData(response?.data?.data)
      })
      .catch(function (response) {})
  }

  return (
    <React.Fragment>
    <div className="page-content">
      <MetaTags>
        <title>{sitename}</title>
      </MetaTags>
      <Container fluid>
        <Breadcrumbs title="Admin" breadcrumbItem="KYC" />
        
      </Container>
      <KYCTable
        data={KYCData}
        call={call}
      />
    </div>
  </React.Fragment> 
  )
}

export default KYC
